import * as yup from 'yup';

export const signInSchema = yup.object({
  password: yup.string().required(),
});
